import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkProcedureTable from "../../components/molecules/TkProcedureTable";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkButton from "../../components/atoms/TkButton";
import { TkGetCodeList, TkGetCode } from "../../utils/TkGetCode";
import {
  DueDateList,
  HandleStatus,
  ProcedureName179,
} from "../../assets/data/Constants";
import { httpAPI_APP001, httpAPI_APP002 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useNavigate } from "react-router";
import { IAPI_APP001_Request, IAPI_APP002_Request } from "../../type/apiType";
import { LatestProcedureInfoList } from "../../type/apiType/IAPI_APP001";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { navigatePath } from "./parts";
import dayjs from "dayjs";

/**
 * SCRD310003 処理依頼履歴
 * @return SCRD310003 処理依頼履歴
 */
const SCRD310003 = () => {
  const navigate = useNavigate();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.searchForHistory;
  const { state, setState } = useContext(GlobalContext);
  const [isShow, setIsShow] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [bodyList, setBodyList] = useState<any>([]);
  const listData: any = [
    {
      keyword: "process",
      type: "selectFrom",
      label: "手続き",
      selectPropsList: TkGetCodeList(ProcedureName179),
      wantToSetValue: context?.businessType,
    },
    {
      keyword: "compatibleDate",
      type: "selectFrom",
      label: "更新日",
      selectPropsList: TkGetCodeList(DueDateList),
      wantToSetValue: context?.dueDate,
    },
  ];

  const handleInit = async (param?: IAPI_APP001_Request) => {
    const paramData: IAPI_APP001_Request = param ?? {
      userId: state.authInfo?.userId,
      businessType: context?.businessType,
      dueDateFrom: context?.dueDateFrom,
      dueDateTo: context?.dueDateTo,
    };
    try {
      const res = await httpAPI_APP001({
        ...paramData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        const dataList = res.latestProcedureInfoList?.map((item) => ({
          important: item.importantFlg === "1" ? true : false,
          progress: TkGetCode(HandleStatus, item.handleStatus),
          date: item.dueDate,
          procedureName: item.businessTypeShortName,
          link: "",
          message: item.procedureTitle,
          timing: item.executionName,
          children: (
            <Box className="button">
              {item.handleStatus === HandleStatus["不要"] ? (
                <TkButton onClick={() => handleBack(item)}>戻す</TkButton>
              ) : item.handleStatus === HandleStatus["削除"] ||
                !item.applyId ? null : (
                <TkButton onClick={() => handleSure(item)}>確認</TkButton>
              )}
            </Box>
          ),
        }));
        setBodyList(dataList ?? []);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (value: any) => {
    if (
      (startDate && !dayjs(startDate, "YYYY/MM/DD", true).isValid()) ||
      (endDate && !dayjs(endDate, "YYYY/MM/DD", true).isValid())
    )
      return;

    let paramData = {
      userId: state.authInfo?.userId,
      businessType: value.process,
      dueDateFrom: startDate,
      dueDateTo: endDate,
    };
    handleInit(paramData);

    setBusinessState({
      searchForHistory: { ...paramData, dueDate: value.compatibleDate },
    });
  };

  const changeStart = (value: any) => {
    setStartDate(value.target.value);
  };

  const changeEnd = (value: any) => {
    setEndDate(value.target.value);
  };

  const handleChangeDate = (e: any, i: any) => {
    if (i === 0) return;

    setStartDate("");
    setEndDate("");

    if (e === DueDateList["自分で選択"]) {
      setIsShow(true);
    } else {
      setIsShow(false);
      setBusinessState({
        searchForHistory: {
          ...context,
          dueDateFrom: "",
          dueDateTo: "",
        },
      });

      if (e === DueDateList["過去１年以上"]) {
        setStartDate("");
        let date = dayjs().subtract(1, "year").format("YYYY/MM/DD");
        setEndDate(date);
      } else if (e === DueDateList["過去１年"]) {
        let date = dayjs().subtract(1, "year").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      } else if (e === DueDateList["過去６ヶ月"]) {
        let date = dayjs().subtract(6, "month").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      } else if (e === DueDateList["過去３ヶ月"]) {
        let date = dayjs().subtract(3, "month").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      } else if (e === DueDateList["過去１ヶ月"]) {
        let date = dayjs().subtract(1, "month").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      }
    }
  };

  const handleSure = (item: LatestProcedureInfoList) => {
    setBusinessState({
      searchForHistory: businessState.searchForHistory,
      common: { businessType: item.businessType },
    });
    navigate(navigatePath[item.businessType!], {
      state: { applyId: item.applyId },
    });
  };

  const handleBack = async (item: any) => {
    const paramData: IAPI_APP002_Request = {
      contractorNo:
        state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
      taskId: item.taskId,
      event: "0",
    };

    try {
      const res = await httpAPI_APP002({
        ...paramData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        const paramData: IAPI_APP001_Request = {
          userId: state.authInfo?.userId,
          businessType: context?.businessType,
          dueDateFrom: context?.dueDateFrom,
          dueDateTo: context?.dueDateTo,
        };
        handleInit(paramData);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRD310003" data-testid="SCRD310003PageForTest">
      <TkSearchForm
        listData={listData}
        onSearch={handleSearch}
        getChangeValue={handleChangeDate}
      />
      {isShow && (
        <Box className="time">
          <Box>更新日（自　〜　至）：</Box>
          <TkDatePicker
            minDate={new Date("1900/01/01")}
            maxDate={new Date()}
            onChange={changeStart}
            wantToSetValue={context?.dueDateFrom}
          />
          <Box>～</Box>
          <TkDatePicker
            minDate={new Date("1900/01/01")}
            maxDate={new Date()}
            onChange={changeEnd}
            wantToSetValue={context?.dueDateTo}
          />
        </Box>
      )}

      <Box className="table">
        <TkProcedureTable
          procedureList={bodyList}
          title=""
          pagin
          maxHeight={800}
          titleChangeToUpdateDay
        />
      </Box>

      <Box className="TkBackButton">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRD310003;
